export default "__VITE_ASSET__$lQ4u90j__"